export default __webpack_public_path__ + "static/media/sales_sourced.5d15ee70.svg";